'use strict';

angular.module('ecrd.core', [
    'sharecrf-auth',
]);
